module.exports = __webpack_public_path__ + "img/4.1aea2263.png";